import { clientId } from '@stvgroup/login-service'
import getEnv from '../env'
import cookies from '../cookies'
/**
 * Reads the Cognito access token cookie, if available
 * @param {object} req - the http request object
 * @returns {(string|null)} - the access token, or null if not found
 */

function getAccessToken(req = {}) {
  const isServer = !process.browser
  if (!req?.headers && isServer) return null
  const env = getEnv()
  const cognitoClientId = clientId(env)
  const lastAuthUserCookie = `CognitoIdentityServiceProvider.${cognitoClientId}.LastAuthUser`
  // handling of cookies with url-encoded keys is inconsistent between client and server
  const lastAuthUser = isServer
    ? encodeURIComponent(cookies.get(lastAuthUserCookie, req))
    : cookies.get(lastAuthUserCookie)
  // eslint-disable-next-line max-len
  const accessTokenCookie = `CognitoIdentityServiceProvider.${cognitoClientId}.${lastAuthUser}.accessToken`
  const accessToken = cookies.get(accessTokenCookie, req)
  return accessToken || null
}

export default getAccessToken
